import script from "./SelectYandexAccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectYandexAccountModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectYandexAccountModal.vue?vue&type=style&index=0&id=6ff98a9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff98a9e"]])

export default __exports__